import React, { useState } from "react";
import * as R from "ramda";
import NotifcationModal from "../../components/notifcationModal";
import { statusName, processRunName, StatusType, ProcessRunStateType, cellClass } from "../helper";

type FixingItem = {
  check?: {
    elvizHeader?: { externalId?: string | null };
    status?: string | null;
  };
  process?: {
    dealCaptureProcessRun?: { state?: string | null };
  };
};

type FixingListCellProps = {
  data: FixingItem[] | null | undefined;
  columnLabel: string;
};

const FixingListCell = ({ data, columnLabel }: FixingListCellProps) => {
  const [open, setOpen] = useState(false);

  if (R.isNil(data) || R.isEmpty(data)) {
    return (<>
      <td className="contrattiCell blackCell">NA</td>
      <td className="contrattiCell blackCell"></td>
      </>
    );
  }

  if (data.length === 1) {
    const item = data[0];
    const checkStatus = R.pathOr("", ["check", "status"], item) as StatusType;
    if (checkStatus === "NA") {
      return (<>
      <td className="contrattiCell blackCell">NA</td>
      <td className="contrattiCell blackCell"></td>
      </>
    );
    }
    const sendStatus = R.pathOr(null, ["process", "dealCaptureProcessRun", "state"], item) as ProcessRunStateType;
    const isRunning = R.pathOr(false, ["process", "isRunning"], item) as boolean;
    const cell = cellClass({ status: checkStatus, isRunning, processRunState: sendStatus });
    return (
       <>
      <td className={`contrattiCell ${cell}`}>{statusName(checkStatus)}</td>
      <td className={`contrattiCell ${cell}`}>{processRunName(sendStatus)}</td>
       </>
    );
  }

  const itemCells = data.map((item: FixingItem) => {
    const status = R.pathOr(null, ["check", "status"], item) as StatusType;
    const processRunState = R.pathOr(null, ["process", "dealCaptureProcessRun", "state"], item) as ProcessRunStateType;
    const isRunning = R.pathOr(false, ["process", "isRunning"], item) as boolean;
    return cellClass({ status, isRunning, processRunState });
  });

  const significantCell = itemCells.find((c: string) => c !== "" && c !== "greenCell");
  const buttonCell = significantCell
    ? significantCell
    : itemCells.every((c: string) => c === "greenCell")
      ? "greenCell"
      : "";

  return (
    <>
      <td className={`contrattiCell ${buttonCell}`}>
        <div
          className="bidding-arrow"
          onClick={() => setOpen(true)}
          title={`Visualizza ${columnLabel}`}
        >
          <i className="fas fa-table"></i>
        </div>
      </td>
      <td className={`contrattiCell ${buttonCell}`}></td>
      <NotifcationModal
        open={open}
        close={() => setOpen(false)}
        title={columnLabel}
        width="large"
        message={
          <div className="modal-body-margin">
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="compactFixingTable">
                <thead>
                  <tr>
                    <th>External Id</th>
                    <th>Check Status</th>
                    <th>Send Status</th>
                  </tr>
                </thead>
                <tbody>
                    {data.map((item: FixingItem, idx: number) => {
                      const status = R.pathOr(null, ["check", "status"], item) as StatusType;
                      const processRunState = R.pathOr(null, ["process", "dealCaptureProcessRun", "state"], item) as ProcessRunStateType;
                      const isRunning = R.pathOr(
                          false,
                          ["process", "isRunning"],
                          item
                        );                      
                        const cell = cellClass({ status, isRunning, processRunState });
                      return (
                        <tr key={idx}>
                          <td>{R.pathOr("", ["check", "externalId"], item)}</td>
                          <td className={cell}>{statusName(status)}</td>
                          <td className={cell}>{processRunName(processRunState)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
          </div>
        }
      />
    </>
  );
};

export default FixingListCell;
